import layout from '@/layout'

export default {
  path: '/pre_close_out',
  component: layout,
  redirect: '/pre_close_out/page8',
  name: 'pre_close_out_page8',
  meta: {
    title: 'pre_close_out',
    icon: 'el-icon-d-arrow-right'
  },
  children: [
    {
      path: '/pre_close_out/page8',
      name: 'pre_close_out_page8',
      component: () => import('@/views/pre_settle/pre_close/out/index8'),
      meta: {
        title: 'pre_close_out_page8',
        icon: 'el-icon-d-arrow-right'
      }
    }
  ]
}
